import React from 'react'
import css from './styles.module.scss'
import InputText from '../AlgoliaArticles/FilterBar/InputText'
import classnames from 'classnames/bind'
import { Text } from 'components/typo'
import { ReactComponent as CheckIcon } from '../MultiSelect/checkIcon.svg'
import SmallArrow from 'components/icons/SmallArrow'
import Image from "next/legacy/image"
import { useState } from 'react'

const cx = classnames.bind(css)

const PartnersSideBar = ({
  fullSearch,
  facets,
  facetFilters,
  setFilter,
  onSearchChange,
}) => {
  const [visibleFilters, setVisibleFilters] = useState(true)
  const [openDropDown, setOpenDropDown] = React.useState(false)

  function toggleFilters() {
    setVisibleFilters(!visibleFilters)
  }

  const hasCountriesFacet = facets.some((facet) => facet.key === 'countries')
  const facetsWithoutCountries = hasCountriesFacet
    ? facets.filter((facet) => facet.key !== 'countries')
    : facets
  const facetsCountries = hasCountriesFacet
    ? facets.filter((facet) => facet.key === 'countries')
    : []

  if (facetsCountries.length > 0) {
    facetsCountries[0].options.sort((a, b) => a.localeCompare(b))
  }

  function toggleDropDown() {
    setOpenDropDown(!openDropDown)
  }
  return (
    <div className={css.sidebar}>
      <div className={css.searchWrapper}>
        <InputText
          className={cx(css.searchP, { full: fullSearch })}
          aria-label="search blog post"
          onChange={onSearchChange}
          placeholder="Search"
          icon="search"
        />
        <button
          className={css.filterBtn}
          theme="white"
          onClick={toggleFilters}
          as="button"
          type="button"
        >
          <Image src="/assets/filter-icon.svg" width={16} height={16} />
        </button>
      </div>

      <div className={cx(css.facets, { [css.facetsHidden]: !visibleFilters })}>
        {facets.length > 0 &&
          facetsWithoutCountries.map((facet, id) => {
            const currentSelected = facetFilters[facet.key]
            if (facet.key === 'type') return null

            return (
              <div key={id}>
                <label className={css.facetsLabel}>{facet.label}</label>
                <ul className={css.options} role="listbox">
                  {facet.options &&
                    facet.options.length > 0 &&
                    facet.options.map((option, index) => (
                      <Text
                        key={index}
                        tag="li"
                        theme="gray"
                        size="small"
                        className={cx(css.option, {
                          checked:
                            currentSelected &&
                            currentSelected.some(
                              (item) => item.label === option
                            ),
                        })}
                        role="option"
                        tabIndex="0"
                        onMouseDown={() => setFilter(facet.key, option)}
                      >
                        <span className={css.box}>
                          <CheckIcon className={css.checkIcon} />
                        </span>
                        {option}
                      </Text>
                    ))}
                </ul>
              </div>
            )
          })}
        {facetsCountries && facetsCountries.length > 0 && (
          <div className={cx(css.Dropdown, { [css.Dropdown]: openDropDown })}>
            <button className={cx(css.Button)} onClick={toggleDropDown}>
              {facetsCountries.map((facet) => facet.label)}
              <SmallArrow
                theme="current-color"
                className={cx(
                  css.smallArrow,
                  openDropDown ? css.arrowUp : css.arrowDown
                )}
              />
            </button>
            <ul
              className={cx({
                [css.OptionList]: openDropDown,
                [css.Hidden]: !openDropDown,
              })}
            >
              {facetsCountries.map(
                (facet, index) =>
                  facet.options &&
                  facet.options.length > 0 &&
                  facet.options?.map((option) => {
                    const currentSelected = facetFilters[facet.key]
                    if (facet.key === 'type') return null
                    return (
                      <li key={option.slug} className={css.MenuLink}>
                        <Text
                          key={index}
                          tag="li"
                          theme="gray"
                          size="small"
                          className={cx(css.option, {
                            checked:
                              currentSelected &&
                              currentSelected.some(
                                (item) => item.label === option
                              ),
                          })}
                          role="option"
                          tabIndex="0"
                          onMouseDown={() => setFilter(facet.key, option)}
                        >
                          <span className={css.box}>
                            <CheckIcon className={css.checkIcon} />
                          </span>
                          {option}
                        </Text>
                      </li>
                    )
                  })
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default PartnersSideBar
